import React from 'react';

import API from '@beardeddevops/react.api';
import Framework from "@beardeddevops/react.framework"
import {Objects, Types, Collections} from "components";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import classNames from "classnames";
import UserRoles from "../../../../../constants/UserRoles";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import {Link} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import {Tooltip} from "@material-ui/core";
import 'react-confirm-alert/src/react-confirm-alert.css';
import TicketScoreBreakdown from "../../../../../components/Parts/TicketScoreBreakdown";


const breadcrumbsStatic = [{
	name: 'Candidate',
	url: '/hiring/search',
	icon: 'ticket',
}];

class Ticket extends Framework.Components.View {

	constructor(props) {
		super(props, "info");
		this.state.next_pkey = null;
		this.state.show_user_create = false;
		this.state.already_exists = false;
		this.state.cand_email = null;
	}

	// async componentDidMount() {
	// 	await this.getNotes();
	// }

	// getNotes = async () => {
	// 	let pkeyModel = new API.BuildClass(Types.Candidates_Notes._name, API.RequestType.READ_ALL);
	// 	pkeyModel.filter = {
	// 		'candidate': this.props.match.params.id,
	// 	}
	// 	pkeyModel.limit = 50;
	// 	let functioning = await pkeyModel.submit(null, 'GET_ALL');
	// 	this.setState({notes: functioning.items})
	//
	// }

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id !== this.props.match.params.id) {
			this.setState({next_pkey: null});
		}
	}


	render() {
		let {match, history, reloadShell, baseUrl} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: ` Candidate ${match.params.id}`,
				url: `/hiring/candidates/${match.params.id}`,
				icon: 'ticket',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}>
					{this.state.show_user_create && <Tooltip
						title={!this.state.already_exists ? "Create a ServiceBookr user for this candidate." : "This candidate already exists either as a temporary user or inside ServiceBookr fully."}>
						<Button size={"sm"} disabled={this.state.already_exists} color="info" onClick={async () => {
							await confirmAlert({
								title: 'Confirm User Creation',
								message: "Are you sure you want to create a ServiceBookr user for this candidate?",
								buttons: [
									{
										label: 'Yes',
										onClick: async () => {
											try {
												let candModel = new API.BuildClass(Types.Hiring_Candidate._name, API.RequestType.READ_ALL);
												candModel.object.pkey = match.params.id;
												candModel.object.name_first = this.state.password;
												const res = await candModel.submit(null, 'POST_CREATE_USER');
												if (res) {
													API.Toast.success("User created! A link was sent to the email on file for this candidate.", {
														position: API.Toast.POSITION.TOP_CENTER,
														autoClose: 10000
													});
												} else {
													console.log(res)
												}

											} catch (error) {
											}
										}
									},
									{
										label: 'No',
										onClick: () => {
										}
									}
								]
							});

						}}>
							Create User
						</Button>
					</Tooltip>}

					{this.state.already_exists &&
						<Button size={"sm"} color="secondary" onClick={async () => {
							await confirmAlert({
								title: 'Resend Link',
								message: ("Are you sure you want to resend the link to ServiceBookr for this candidate? It will go to " + (this.state.cand_email ? this.state.cand_email : 'MISSING') + ". If this is incorrect, please update their email first."),
								buttons: [
									{
										label: 'Yes',
										onClick: async () => {
											try {
												let candModel = new API.BuildClass(Types.Hiring_Candidate._name, API.RequestType.READ_ALL);
												candModel.object.pkey = match.params.id;
												await candModel.submit(null, 'GET_RESEND_LINK');
												API.Toast.success("Link resent!", {
													position: API.Toast.POSITION.TOP_CENTER,
													autoClose: 10000
												});
											} catch (error) {
											}
										}
									},
									{
										label: 'No',
										onClick: () => {
										}
									}
								]
							});

						}}>
							Resend Link
						</Button>
					}

					{this.state.already_exists &&
						<Button size={"sm"} color="info">
							<Link to={'/users/' + this.state.already_exists} style={{color: '#fff', fontWeight: 500}}>
								To User
							</Link>
						</Button>
					}

					{this.state.next_pkey &&

						<Link to={`/hiring/candidates/${this.state.next_pkey}#notes`}>
							<Button size={"sm"} color="primary">
								Go To Next Candidate
							</Button>
						</Link>}

				</Framework.Components.PageBar>

				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}>
					<Tab label="Information" value="info"/>
					{/*<Tab label="Documents" value="docs"/>*/}
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'info'})}>
					<Objects.Candidate
						id={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						noDelete={!!this.props.roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Executive].includes(role))}
						goBack={true}
						afterDelete={() => {
							this.props.history.goBack()
						}}
						render_next_button={(pkey) =>
							this.setState({next_pkey: pkey})
						}
						show_user_create_button={(value) => {
							this.setState({show_user_create: value})
						}}
						set_already_exists={(value) => {
							this.setState({already_exists: value})
						}}
						update_email={(value) => {
							this.setState({cand_email: value})
						}}
						update_base_pay={(value) => {
							this.setState({base_pay: value})
						}}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'docs'})}>

					{/*TODO put documents here*/}

				</div>
			</div>
		)
	}
}

export default Framework.Components.withRootState(Ticket);
